import React, { FC } from 'react';
import styled from 'styled-components';
import { useBreakpoints } from 'logic/hooks/use-breakpoints';
import { Text } from '../../../components/text/Text';
import ImgWrapper from '../../../components/Image/ImageWrapper';
import moment from 'moment';

const NewsOverviewContainer = styled.div<{ min500: boolean }>`
  display: flex;
  flex-direction: ${({ min500 }) => (min500 ? 'row' : 'column')};
  justify-content: center;
  align-items: center;
  gap: 24px;
`;

const Details = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  gap: 8px;
`;

const OptionalLink = styled.a<{ hasLink: boolean }>`
  &:hover {
    cursor: ${({ hasLink }) => (hasLink ? 'pointer' : 'default')};
    opacity: ${({ hasLink }) => (hasLink ? '80%' : undefined)};
  }
`;

export const NewsOverview: FC<{
  image: any;
  headline: string;
  link?: string;
  category?: string;
  author?: string;
  date?: any;
}> = ({ link, image, category, headline, author, date }) => {
  const { maxMobileLarge, min500 } = useBreakpoints();
  const authorText = author ? author : '';
  const slashText = author && date ? ' / ' : '';
  const dateText = date ? moment(date).format('DD.MM.YYYY') : '';

  return (
    <OptionalLink
      href={link ? link : undefined}
      target="_blank"
      rel="noreferrer"
      hasLink={link ? true : false}
    >
      <NewsOverviewContainer min500={min500}>
        <ImgWrapper
          width={maxMobileLarge ? '100%' : 210}
          height={maxMobileLarge ? '100%' : 140}
          img={image}
          style={{ aspectRatio: '1.5', borderRadius: '4px' }}
        />
        <Details>
          <Text fontWeight={600} size={12} color={'blue2'} textAlign={min500 ? 'left' : 'center'}>
            {category && category.toUpperCase()}
          </Text>
          <Text fontWeight={600} size={18} textAlign={min500 ? 'left' : 'center'}>
            {headline}
          </Text>
          <Text fontWeight={600} size={12} color={'gray14'} textAlign={min500 ? 'left' : 'center'}>
            {authorText + slashText + dateText}
          </Text>
        </Details>
      </NewsOverviewContainer>
    </OptionalLink>
  );
};
